/* eslint-disable space-before-blocks */
import http from '../utils/http';
import i18n from '@/main';
import axios from 'axios';

const baseUrl = '/territorios';

export default {
    findAll(params) {
        return http.get({
            url:
                baseUrl +
                `/buscaTerritorioPaginado?page=${params.page}&size=${params.size}${params.order}&searchText=${params.search}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },
    findAllAgricolaFilter(params, filtros) {
        return http.post({
            url:
                baseUrl +
                `/buscaTerritorioPaginadoFiltroAgricola?page=${params.pagina}&size=${params.tamanho}&sort=${params.ordenacao}`,
            lockScreen: false,
            data: JSON.parse(JSON.stringify(filtros)),
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findByMapaHome() {
        return http.get({
            url: baseUrl + '/mapa-home',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findGeometriaByIdTerritorio(idTerritorio) {
        return http.get({
            url: baseUrl + `/geometria-territorio/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoGeometriaDoTerritorio'
            )
        });
    },

    findGeometriaByIdTerritorioMunicipio(municipioId) {
        return http.get({
            url: baseUrl + `/geometria-territorio-municipio/${municipioId}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoGeometriaDoMunicipio'
            )
        });
    },

    findGeometriaByIdTerritorioLocalidade(localidadeId) {
        return http.get({
            url: baseUrl + `/geometria-territorio-localidade/${localidadeId}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoGeometriaDoMunicipio'
            )
        });
    },

    findById(territorioId) {
        return http.get({
            url: baseUrl + `/${territorioId}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findInteligente(filtro) {
        return http.get({
            url: baseUrl + `/consulta?consultar=${filtro}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },

    findAllPaginadoSocioAmbiental(params) {
        return http.post({
            url:
                baseUrl +
                `/socioambiental/buscaTerritorioPaginado?page=${params.page}&size=${params.size}${params.order}`,
            data: { ...params.filtro },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    add(territorio) {
        return http.post({
            url: baseUrl + '',
            data: { ...territorio },
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.salvandoTerritorioAtualizado'
            )
        });
    },

    validarSobreposicaoTerritorio(geometria, id) {
        return http.post({
            url: baseUrl + '/validar-sobreposicao-territorio',
            data: { geoJson: geometria, idTerritorio: id },
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.validandoSobreposicaoDeTerritoriosCadastrados'
            )
        });
    },

    delete(territorioId) {
        return http.delete({
            url: baseUrl,
            data: { territorioId },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoTerritorio')
        });
    },

    deleteAR(territorioId) {
        return http.post({
            url: baseUrl + `/delete-territorio-ar?territorioId=${territorioId}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoTerritorio')
        });
    },

    update(territorio) {
        return http.put({
            url: baseUrl + `/atualizar/${territorio.id}`,
            data: { ...territorio },
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.salvandoTerritorioAtualizado'
            )
        });
    },

    findByCar(car) {
        return http.get({
            url: baseUrl + `/car/${car}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },

    verificarRepresentante(idRepresentante) {
        return http.get({
            url: baseUrl + `/verificar?idRepresentante=${idRepresentante}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.verificandoSeORepresentantePossuiTerritorio'
            )
        });
    },

    consolidaTerritorio(listaTerritorio) {
        return http.post({
            url: baseUrl + `/consolidar-territorio`,
            data: listaTerritorio,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.consolidandoTerritorio')
        });
    },

    emaiTerritorio(id, email) {
        return http.post({
            url: baseUrl + `ar/enviar-email-territorio/` + id,
            data: email,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.consolidandoTerritorio')
        });
    },

    diagnosticoSocioambiental(idTerritorio, salvar = true) {
        return http.get({
            url:
                baseUrl +
                `/socioambiental/por-territorio/${idTerritorio}?salvar=${salvar}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.realizandoDiagnostico')
        });
    },

    findAllSimplificado(filtro = '') {
        return http.get({
            url: baseUrl + `/simplificado?filtro=${filtro}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findSimplificadoPorCar(car) {
        return http.get({
            url: baseUrl + `/simplificado/car/${car}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    findAllSimplificadoPaginado(params, filtro = '') {
        return http.get({
            url: `${baseUrl}/simplificado-paginado?page=${params.page}&size=${params.size}&filtro=${filtro}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    solicitacaoLaudo(listaTerritorios) {
        return http.post({
            url: baseUrl + `/solicitacao`,
            data: listaTerritorios,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.solicitandoTerritorios')
        });
    },

    findCarsByTerritorio(territorio) {
        return http.post({
            url: baseUrl + `/cars/por-territorio/`,
            data: { ...territorio },
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.verificandoSobreposicaoDeCars'
            )
        });
    },

    findProdutos() {
        return http.get({
            url: baseUrl + `/produtos`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoProdutos')
        });
    },

    findUnidadesMedida() {
        return http.get({
            url: baseUrl + `/unidade-medidas`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoUnidadesDeMedida')
        });
    },

    updateComercializacoes(territorio) {
        return http.put({
            url: baseUrl + `/comercializacoes/${territorio.id}`,
            data: territorio.comercializacoes,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.atualizandoComercializacoes')
        });
    },

    getStatusMonitoramento(idTerritorio) {
        return http.get({
            url: baseUrl + `/${idTerritorio}/status-monitoramento`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.verificandoSeOTerritorioEstaEmMonitoramento'
            )
        });
    },

    buscarTipoCertificacao() {
        return http.get({
            url: baseUrl + `/tipo-certificacao`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTipoDeCertificacao')
        });
    },

    realizarPesquisaInteligente(filtro) {
        return http.get({
            url: baseUrl + `/pesquisa-inteligente?filtro=${filtro}`,
            lockScreen: false
        });
    },

    buscarTerritoriosPorIdRepresentante(idRepresentante) {
        return http.get({
            url: baseUrl + `/representante/${idRepresentante}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoTerritoriosDoRepresentante'
            )
        });
    },

    filtrarCadastroGleba(filtro) {
        return http.get({
            url: baseUrl + `/filtrar/cadastro/gleba?filtro=${filtro}`,
            lockScreen: false
        });
    },

    buscarCadastroGleba(idTerritorio) {
        return http.get({
            url: baseUrl + `/${idTerritorio}/buscar/cadastro/gleba`,
            lockScreen: false
        });
    },
    buscarSituacaoCamadaCategoria(idTerritorio) {
        return http.get({
            url: baseUrl + `/socio-ambiental/situacao/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoSituacaoDoTerritorio'
            )
        });
    },

    _buscarContratoOriginacao(search, lockScreen = true) {
        return http.get({
            url: baseUrl + `/buscaTerritorioPaginado?searchText=${search}`,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    async certificarTerritorio(id) {
        return axios.post(`/api/territorios/${id}/certificar`);
    },

    buscarDepartamentosParaguay() {
        return http.get({
            url: baseUrl + '/departamento',
            lockScreen: false
        });
    },

    buscarDistritosParaguay(idDepartamentoParaguay) {
        return http.get({
            url: baseUrl + `/distrito/${idDepartamentoParaguay}`,
            lockScreen: false
        });
    },

    validacaoDadosCadastroParaguay(
        idDepartamentoParaguay,
        idDistritoParaguay,
        padronParaguay
    ) {
        return http.get({
            url:
                baseUrl +
                `/validacao-dados?dpto=${idDepartamentoParaguay}&dist=${idDistritoParaguay}&padron=${padronParaguay}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.validacaoCatastro')
        });
    },

    validaSobreposicaoCatastroParaguay(
        geometria,
        idDepartamentoParaguay,
        idDistritoParaguay,
        padronParaguay
    ) {
        return http.post({
            url: baseUrl + `/validacao-sobrePosicao`,
            data: {
                geoJson: geometria,
                dpto: idDepartamentoParaguay,
                dist: idDistritoParaguay,
                padron: padronParaguay
            },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.sobreposicaoCatastro')
        });
    },

    validaIntersecoesTerritoriosParaguay(geometria, territorio) {
        return http.post({
            url: baseUrl + `/valida-intersection-territorioPY`,
            data: { geoJson: geometria, idTerritorio: territorio },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.intersecaoCatastro')
        });
    },

    updateParaguay(territorio, camposParaguay) {
        territorio.dpto = camposParaguay.departamento;
        const idDistrito = camposParaguay.distrito.replace(/\D/g, '');

        territorio.dist = idDistrito;
        territorio.padron = camposParaguay.padron;
        territorio.finca = camposParaguay.finca;

        territorio.informacoesAgricolas =
            territorio.informacoesAgricolas.length === 0
                ? null
                : territorio.informacoesAgricolas;

        if (territorio.representantes && territorio.representantes.length > 0) {
            territorio.representantes.forEach(representante => {
                representante.tipoDocumento = representante.idTipoDocumento;
            });
        }

        return http.postFormData({
            url: baseUrl + `/update-territorioPY/${territorio.id}`,
            data: { ...territorio },
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.salvandoTerritorioAtualizado'
            )
        });
    },

    addParaguay(territorio, camposParaguay) {
        territorio.dpto = camposParaguay.departamento;
        const idDistrito = camposParaguay.distrito.replace(/\D/g, '');
        territorio.dist = idDistrito;
        territorio.padron = camposParaguay.padron;

        territorio.finca = camposParaguay.finca;

        territorio.informacoesAgricolas =
            territorio.informacoesAgricolas.length === 0
                ? null
                : territorio.informacoesAgricolas;

        return http.postFormData({
            url: baseUrl + '/inserir-territorioPY',
            data: { ...territorio },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.territorioComSucesso')
        });
    },

    exportarTerritorios(simplificado) {
        return http.get({
            url: baseUrl + `/exportar/${simplificado}`,
            responseType: 'blob',
            lockScreen: false
        });
    },

    buscarTerritorioPorFincaOrPadron(valor, departamento, distrito) {
        return http.get({
            url:
                baseUrl +
                `/paraguai/finca/?finca=${valor}&padron=${valor}&dpto=${departamento}&dist=${distrito}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },

    buscarTerritoriosVinculadosPessoaPY(valor) {
        return http.get({
            url:
                baseUrl +
                `/buscar-territorios/vinculado-pessoaPY/?idRepresentante=${valor}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },

    buscarTerritoriosVinculadosPessoaAR(valor) {
        return http.get({
            url:
                baseUrl +
                `/buscar-territorios/vinculado-pessoaAR/?idRepresentante=${valor}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },

    buscarTerritoriosRevenda(filtro) {
        return http.post({
            url: `/territorios/buscar-territorios/sem-pessoa-vinculadoAR`,
            data: filtro,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },

    buscarTerritoriosRevendaPY(filtro) {
        return http.post({
            url: `/territorios/buscar-territorios/sem-pessoa-vinculadoPY`,
            data: filtro,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },
    atualizarCertificacaoTerritorio(
        idTerritorio,
        idTipoCertificacao,
        certificado
    ) {
        return http.put({
            url:
                baseUrl +
                `/${idTerritorio}/certificacao/?idTipoCertificacao=${idTipoCertificacao}&certificado=${certificado}`
        });
    },
    territoriosArgentinaVizualizar(params) {
        return http.get({
            url:
                baseUrl +
                `/ar?page=${params.page}&size=${params.size}${params.order}&filtro=${params.search}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },
    territoriosPendentes(page, size) {
        return http.get({
            url: baseUrl + `/ar/aprovacoes-pendentes?page=${page}&size=${size}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },
    aprovarOuReprovarTerritorio(mensagem, isAprove, idTerritorio) {
        return http.post({
            url: baseUrl + '/ar/aprovar-reprovar',
            data: { obersevacao: mensagem, aprovado: isAprove, idTerritorio },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.territorioComSucesso')
        });
    },
    vizualizarTerritorioPendente(idTerritorio) {
        return http.get({
            url: baseUrl + `/buscar-territorioPY/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    addArgentina(territorio) {
        territorio.informacoesAgricolas =
            territorio.informacoesAgricolas.length === 0
                ? null
                : territorio.informacoesAgricolas;

        return http.postFormDataAr({
            url: baseUrl + `/ar/inserir`,
            data: { ...territorio },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios'),
            responseType: 'blob'
        });
    },
    updateArgentina(territorio, id) {
        //  const idDistrito = camposParaguay.distrito.codigo.replace(/\D/g, '');

        // territorio.dist = idDistrito;
        // territorio.padron = camposParaguay.padron;
        // territorio.finca = camposParaguay.finca;
        territorio.informacoesAgricolas =
            territorio.informacoesAgricolas.length === 0
                ? null
                : territorio.informacoesAgricolas;

        return http.putFormDataAr({
            url: baseUrl + `/ar/update/` + id,
            data: { ...territorio },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.territorioComSucesso')
        });
    },
    obterProvinciaPorCodigoArgentina(codigo) {
        return http.get({
            url: baseUrl + `/ar/obter-provincia-por-codigo/` + codigo,
            lockScreen: false
        });
    },
    listaPapeis() {
        return http.get({
            url: '/representantes/ar/papeis',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },
    validacaoTerritorioRenspa(codigoRenspa, idTerritorio) {
        return http.get({
            url:
                baseUrl +
                `/ar/verifica-renspa/` +
                codigoRenspa +
                `/` +
                idTerritorio,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },
    preValicadaoAtualizacaoAr(territorio, id) {
        return http.post({
            url: baseUrl + `/ar/pre-validacao-atualizaca-ar?territorioId=${id}`,
            data: { ...territorio },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    }
};
